<script>
import Layout from "@/router/layouts/auth";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";

export default {
  locales: {
    pt: {
      'Username': 'Usuário',
      'Username is required.': 'Usuário é obrigatório.',
      'E-mail': 'E-mail',
      'E-mail is required.': 'E-mail é obrigatório.',
      'This value should be a valid e-mail.': 'Este valor deve ser um e-mail válido.',
      'Recover': 'Recuperar',
      'Remember It?': 'Lembrou-se?',
      'Sign In here': 'Entrar',
      'The CPF/CNPJ and/or password is incorrect.': 'O CPF/CNPJ e/ou email é inválido.',
      'A code for creating a new password has been sent to your email and you have up to 24 hours to change your password.': 'Um código para criar uma nova senha foi enviado ao seu e-mail e você tem até 24 horas para alterar sua senha.',
    },
    es: {
      'Username': 'Nombre de usuario',
      'Username is required.': 'Se requiere nombre de usuario.',
      'E-mail': 'E-mail',
      'E-mail is required.': 'Correo electronico es requerido.',
      'This value should be a valid e-mail.': 'Este valor debe ser un correo electrónico válido.',
      'Recover': 'Recuperar',
      'Remember It?': '¿Recuerdalo?',
      'Sign In here': 'Identifícate aquí',
      'The CPF/CNPJ and/or password is incorrect.': 'El CPF/CNPJ e/o correo electrónico no es válido.',
      'A code for creating a new password has been sent to your email and you have up to 24 hours to change your password.': 'Se ha enviado un código para crear una nueva contraseña a su correo electrónico y tiene hasta 24 horas para cambiar su contraseña.',
    }
  },
  components: {
    Layout,
    Languages
  },
  data() {
    return {
      loading: false,
      success: false,

      personNumberMask: "###.###.###-##",
      personNumber: "",
    };
  },
  computed: {
    ...mapState({
      alert: state => state.alert
    })
  },
  validations: {
    personNumber: { required },
  },
  methods: {
    recoverSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true

        if (this.personNumber) {
          api
            .post('password/recover', {
              personNumber: this.personNumber,
            })
            .then(response => {
              if (response.data.status=='success') {
                this.personNumber = ''
                this.$v.$reset()

                this.alert.type = 'alert-success'
                this.alert.message = response.data.message

                this.success = true
              } else {
                this.alert.type = 'alert-danger'
                this.alert.message = response.data.message
              }

              this.loading = false
            })
        }
      }
    }
  },
};
</script>

<template>
  <Layout>
    <div id="auth">
      <div class="login-content d-flex">
        <div class="flex-fill">
          <div class="pt-5 pb-2 text-center">
            <router-link class="align-middle" tag="a" to="/">
              <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
            </router-link>
          </div>
          <div class="py-5">
            <div v-if="success">
              {{ t(this.alert.message) }}
            </div>
            <b-form v-else @submit.prevent="recoverSubmit">
              <div v-if="alert.message" :class="'alert ' + alert.type">
                {{ t(alert.message) }}
              </div>
              <b-form-group id="personNumber" :label="t('CPF/CNPJ')" label-for="personNumber">
                <b-form-input id="personNumber" v-model="personNumber" type="text" :class="{ 'is-invalid': $v.personNumber.$error }" v-mask="personNumberMask"></b-form-input>
                <div v-if="$v.personNumber.$error" class="invalid-feedback">
                  <span v-if="!$v.personNumber.required">{{ t('Username is required.') }}</span>
                </div>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                  {{ t("Recover") }}
                  <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                </b-button>
              </div>
              <div class="text-center pt-5">
                {{ t("Remember It?") }}
                <router-link tag="a" to="/login" class="d-block btn btn-outline-default btn-lg btn-block mt-2">{{ t("Sign In here") }}</router-link>
                <Languages class="d-none" type="dropup"></Languages>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
